import React from 'react';
import { Tooltip } from '@mui/material';
import { Block as BlockIcon } from '@mui/icons-material';
import styles from './ExcludeByDateBadge.module.scss';

export type ExcludeByDateBadgeProps = {
  tooltipTitle: string;
  ariaLabel: string;
  label?: string;
};

export function ExcludeByDateBadge({
  tooltipTitle,
  ariaLabel,
  label = 'skipped',
}: ExcludeByDateBadgeProps) {
  return (
    <Tooltip title={tooltipTitle} enterDelay={400}>
      <div
        className={styles.excludeBadge}
        aria-label={ariaLabel}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <BlockIcon className={styles.excludeBadgeIcon} aria-hidden fontSize="inherit" />
        {label}
      </div>
    </Tooltip>
  );
}
